export const TOGGLE_BUTTONS_ARRAY_BUTTON = 'TOGGLE_BUTTONS_ARRAY_BUTTON'
export const CHANGE_BUTTONS_ARRAY_BUTTON = 'CHANGE_BUTTONS_ARRAY_BUTTON'
